import { combineReducers } from "@reduxjs/toolkit";
import requestOtp from "./requestOTPSlice";
import verifyOtp from "./verifyOTPslice";
import validateIFSC from "./ifscSlice";
import validatePAN from "./validatePAN";
import genericInformation from "./genericInformation";
import validateBank from "./validateBank";
import submitKYC from "./submitKYCSlice";

const RootReducer = combineReducers({
  info: genericInformation,
  otp: requestOtp,
  verifyOtp: verifyOtp,
  ifsc: validateIFSC,
  pan: validatePAN,
  bank: validateBank,
  kycStatus: submitKYC,
});

export default RootReducer;
